/* ==============================================================
   GABBIANO — Winterjassen-landingspagina: jassenvinder
   Hoort bij sections/gb-wj-finder.liquid en gb-wj-compare.liquid.
   De vinder kiest een match-blok op lengte + stijl en stuurt de
   producthandle door, zodat de vergelijkingstabel die kolom markeert.
   ============================================================== */
(function () {
  function initFinder(root) {
    if (!root || root.dataset.gbwjReady) return;
    root.dataset.gbwjReady = '1';
    var matches = Array.prototype.slice.call(root.querySelectorAll('[data-gbwj-match]'));
    var note = root.querySelectorAll('[data-gbwj-note]');
    var state = { len: root.dataset.defaultLen || 'kort', sty: root.dataset.defaultSty || 'clean' };

    function pick() {
      var exact = matches.filter(function (m) { return m.dataset.len === state.len && m.dataset.sty === state.sty; })[0];
      var chosen = exact
        || matches.filter(function (m) { return m.dataset.sty === state.sty; })[0]
        || matches.filter(function (m) { return m.dataset.len === state.len; })[0]
        || matches[0];
      matches.forEach(function (m) { m.hidden = m !== chosen; });
      Array.prototype.forEach.call(note, function (n) { n.hidden = !!exact; });
      root.querySelectorAll('[data-gbwj-opt]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', state[btn.dataset.gbwjOpt] === btn.dataset.value ? 'true' : 'false');
      });
      if (chosen) {
        document.dispatchEvent(new CustomEvent('gbwj:match', { detail: { handle: chosen.dataset.handle } }));
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gbwj-opt]');
      if (!btn) return;
      state[btn.dataset.gbwjOpt] = btn.dataset.value;
      pick();
    });
    pick();
  }

  function highlight(handle) {
    document.querySelectorAll('[data-gbwj-compare]').forEach(function (table) {
      table.querySelectorAll('[data-handle]').forEach(function (cell) {
        cell.classList.toggle('is-match', !!handle && cell.dataset.handle === handle);
      });
      table.dataset.gbwjLast = handle || '';
    });
  }

  var lastHandle = '';
  document.addEventListener('gbwj:match', function (e) {
    lastHandle = e.detail.handle;
    highlight(lastHandle);
  });

  function initAll() {
    document.querySelectorAll('[data-gbwj-finder]').forEach(initFinder);
    if (lastHandle) highlight(lastHandle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* Theme-editor: secties worden opnieuw gerenderd bij elke wijziging */
  document.addEventListener('shopify:section:load', initAll);
})();
